import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { Toaster as Sonner, type ToasterProps as SonnerProps } from 'sonner'

export type ToasterProps = SonnerProps

export function Toaster({ className, ...props }: ToasterProps): JSX.Element {
  return (
    <Sonner
      className={cn(
        'toaster group',
        // Sonner sets --width:356px inline. The OOSA IDT toast is 640px
        // in Figma; grow the right-aligned tray left so it stays on screen.
        'has-data-oosa-idt-toast:[--width:min(640px,calc(100vw-64px))]!',
        className
      )}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          closeButton:
            'group-[.toast]:bg-background group-[.toast]:border-border group-[.toast]:text-foreground hover:group-[.toast]:bg-accent hover:group-[.toast]:text-accent-foreground',
        },
      }}
      {...props}
    />
  )
}
